<lib-chart-bar disableLegend [chartConf]="conf"/>